export default "__VITE_ASSET__DEHO8HZJ__"